<template>
  <div class="modal-backdrop">
    <div class="modal-content">
      <div class="mt-4 mb-2 col-12">
        <h3>Select Line and Hopper to bag</h3>
        <h6 v-if="modal_selected_line === null" class="mt-2 mb-2">
          Select Line
        </h6>
        <h6 v-if="modal_selected_line !== null" class="mt-2 mb-2">
          Selected Line
        </h6>
        <div class="mt-2 mb-2"
          :style="{ position: 'relative', pointerEvents: modal_lines.length === 1 ? 'none' : 'auto' }" @click.stop="
            modal_lines.length > 1 && (modalLinesDropdownVisible = !modalLinesDropdownVisible);
          modalHoppersDropdownVisible = false;
          ">
          <button class="form-control">
            {{
              modal_selected_line
                ? modal_selected_line.name
                : modal_lines.length > 0
                  ? "Click here to select a Line"
                  : "No Lines to select"
            }}
          </button>
          <div v-if="modalLinesDropdownVisible" class="dropdown-menu show w-100"
            style="border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)">
            <input v-model="searchQueryModalLine" class="form-control mt-1 mb-2 ms-2 w-90" type="text"
              placeholder="Search..." @click.stop />
            <div v-for="modalLine in filteredModalLines" :key="modalLine.id" class="dropdown-item"
              style="cursor: pointer" @click.stop="updateSelectedModalLine(modalLine)">
              {{ modalLine.name }}
            </div>
          </div>
        </div>
        <div>
          <h6 v-if="modal_selected_hopper === null" class="mt-2 mb-2">
            Select Hopper
          </h6>
          <h6 v-if="modal_selected_hopper !== null" class="mt-2 mb-2">
            Selected Hopper
          </h6>
          <div class="mt-2 mb-2"
            :style="{ position: 'relative', pointerEvents: modal_hoppers.length === 1 ? 'none' : 'auto' }" @click.stop="
              modal_hoppers.length > 1 && (modalHoppersDropdownVisible = !modalHoppersDropdownVisible);
            modalLinesDropdownVisible = false;
            ">
            <button class="form-control">
              {{
                modal_selected_hopper
                  ? modal_selected_hopper.name
                  : modal_hoppers.length > 0
                    ? "Click here to select a Hopper"
                    : "No Hoppers to select"
              }}
            </button>
            <div v-if="modalHoppersDropdownVisible" class="dropdown-menu show w-100"
              style="border: 1px solid #ccc; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)">
              <input v-model="searchQueryModalHopper" class="form-control mt-1 mb-2 ms-2 w-90" type="text"
                placeholder="Search..." @click.stop />
              <div v-for="modalHopper in filteredModalHoppers" :key="modalHopper.id" class="dropdown-item"
                style="cursor: pointer" @click.stop="updateSelectedModalHopper(modalHopper)">
                {{ modalHopper.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="actions">
          <button type="button" class="btn bg-gradient-danger btn-sm w-100 mt-4 mb-0"
            @click="$emit('validated', {status: 'cancel'})">
            Cancel
          </button>
            <button 
            type="button" 
            class="btn btn-sm w-100 mt-4 mb-0" 
            :class="{
              'bg-gradient-success': modal_selected_line && modal_selected_hopper,
              'bg-gradient-secondary': !modal_selected_line || !modal_selected_hopper
            }" 
            :disabled="!modal_selected_line || !modal_selected_hopper" 
            @click="goToNewBagging">
            Start New Bagging
            </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "NewBaggingModal",
  components: {
  },
  props: {
  },
  emits: [
    'validated',
  ],
  data() {
    return {
      modal_lines: [],
      modal_selected_line: null,
      modalLinesDropdownVisible: false,
      searchQueryModalLine: "",
      modal_hoppers: [],
      modal_selected_hopper: null,
      modalHoppersDropdownVisible: false,
      searchQueryModalHopper: "",
    };
  },
  computed: {
    filteredModalLines() {
      return this.modal_lines.filter(line => line.name.toLowerCase().includes(this.searchQueryModalLine.toLowerCase()));
    },
    filteredModalHoppers() {
      return this.modal_hoppers.filter(hopper => hopper.name.toLowerCase().includes(this.searchQueryModalHopper.toLowerCase()));
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        let response = await axios.get("api/v1/steelcase/coatingbooth/");
        this.modal_lines = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    goToNewBagging(){
      if (this.modal_selected_hopper === null || this.modal_selected_line === null) {
        return;
      }
      this.$emit('validated', {
        line_id: this.modal_selected_line.id,
        hopper_id: this.modal_selected_hopper.id,
        status: 'new_bagging',
      });
    },
    async updateSelectedModalLine(line) {
      this.modal_selected_line = line;
      this.modalLinesDropdownVisible = false;
      this.modalHoppersDropdownVisible = false;
      await this.getHoppers();
    },
    async updateSelectedModalHopper(hopper) {
      this.modal_selected_hopper = hopper;
      this.modalHoppersDropdownVisible = false;
      this.modalLinesDropdownVisible = false;
    },
    async getHoppers() {
      if (this.modal_selected_line.id === null) {
        return;
      }
      try {
        let response = await axios.get("api/v1/steelcase/hopper/coating-booth/" + this.modal_selected_line.id + "/");
        this.modal_hoppers = response.data;
        if (this.modal_hoppers.length === 1) {
          this.modal_selected_hopper = this.modal_hoppers[0];
        }
      }
      catch (error) {
        console.error(error);
      }
    },
    async createAnotherBagging() {
      try {

        // create a temp for bagging
        // patch with the selected hopper
        // redirect to this other Bagging
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 600px;
  max-width: 90%;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.btn {
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.accept {
  background: #4caf50;
  color: white;
}

.alert {
  background: #ff9800;
  color: white;
}

.reject {
  background: #f44336;
  color: white;
}
</style>
